import {
  BOOKINGS_FETCH_REQUEST,
  BOOKINGS_FETCH_SUCCESS,
  BOOKINGS_FETCH_FAIL,
  BOOKING_CANCEL_REQUEST,
  BOOKING_CANCEL_SUCCESS,
  BOOKING_CANCEL_FAIL,
} from "../constants/BookingConstants";
import { cancelBooking, getAllBookings } from "../services/bookingService";

export const fetchBookings = () => async (dispatch) => {
  dispatch({ type: BOOKINGS_FETCH_REQUEST });

  try {
    const data = await getAllBookings();
    const sorted = [...data].sort((a, b) => (b.bId || 0) - (a.bId || 0));
    dispatch({ type: BOOKINGS_FETCH_SUCCESS, payload: sorted });
    return sorted;
  } catch (error) {
    dispatch({
      type: BOOKINGS_FETCH_FAIL,
      payload: error?.response?.data?.message || error?.message || "Failed to fetch bookings.",
    });
    throw error;
  }
};

export const cancelBookingById = (booking) => async (dispatch) => {
  dispatch({ type: BOOKING_CANCEL_REQUEST, payload: booking?.bId });

  try {
    await cancelBooking(booking);
    dispatch({
      type: BOOKING_CANCEL_SUCCESS,
      payload: { bookingId: booking.bId, status: "Cancel" },
    });
  } catch (error) {
    dispatch({
      type: BOOKING_CANCEL_FAIL,
      payload: {
        bookingId: booking?.bId,
        message: error?.response?.data?.message || error?.message || "Failed to cancel booking.",
      },
    });
    throw error;
  }
};
